import React from 'react'
import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';
import InterfaceEdit from './InterfaceEdit';
import InterfaceDel from './InterfaceDel';
import BackendAdd from '../backend/BackendAdd';
import StateButton from './StateButton';

function InterfaceDropdown(props) {
    console.log(props,'2222');
    
    // 字段映射：将父组件传递的字段映射为子组件期望的字段
    const mappedProps = {
        ...props,
        et_bg_id: props.bg_id,
        et_bg_name: props.bg_name,
        et_bgn_id: props.bgn_id,
        et_bgn_name: props.bgn_name,
        et_bbb_id: props.bbb_id,
        et_bbb_name: props.bbb_name,
    };
    
    const items = [
        {
            label: (
                <InterfaceEdit
                    bgn_id={props.bgn_id}                                                     
                    bgn_name={props.bgn_name} 
                    bg_id={props.bg_id}
                    bg_name={props.bg_name}
                    bg_dept_id={props.bg_dept_id}
                    bg_dept_name={props.bg_dept_name}
                    bbb_id={props.bbb_id}
                    bbb_name={props.bbb_name}
                    et_id={props.et_id}
                    et_name={props.et_name}
                    et_uid={props.et_uid}
                />
            ),
            key: 'ModuleEdit',
        },
        {
            label: (
                <InterfaceDel et_id={props.et_id} et_uid={props.et_uid}/>
            ),
            key: 'ModuleDel',
        },              
        {
            type: 'divider',
        }, 
        {
            label: (
                <BackendAdd
                    bgn_id={props.bgn_id}                                                     
                    bgn_name={props.bgn_name} 
                    bg_id={props.bg_id}
                    bg_name={props.bg_name}
                    bg_dept_id={props.bg_dept_id}
                    bg_dept_name={props.bg_dept_name}
                    bbb_id={props.bbb_id}
                    bbb_name={props.bbb_name}
                    et_id={props.et_id}
                    et_name={props.et_name}
                    et_uid={props.et_uid}
                />
            ),
            key: 'SubmoduleAdd',
        }, 
    ];
    return (
        <Space>
            <StateButton 
                et_uid={mappedProps.et_uid}
                et_e_id={mappedProps.et_e_id}
                et_name={mappedProps.et_name}
                et_content={mappedProps.et_content}
                et_update_uid={mappedProps.et_update_uid}
                et_update_uname={mappedProps.et_update_uname}
                etu_user_id={mappedProps.etu_user_id}
                etu_user_name={mappedProps.etu_user_name}
                et_id={mappedProps.et_id}
                et_date={mappedProps.et_date}
                et_status={mappedProps.et_status}
                et_grade={mappedProps.et_grade}
                et_bg_id={mappedProps.et_bg_id}
                et_bg_name={mappedProps.et_bg_name}
                et_bgn_id={mappedProps.et_bgn_id}
                et_bgn_name={mappedProps.et_bgn_name}
                et_bbb_id={mappedProps.et_bbb_id}
                et_bbb_name={mappedProps.et_bbb_name}
                eu_id={mappedProps.eu_id}
                eu_name={mappedProps.eu_name}
            />
            <Dropdown menu={{ items }} trigger={['click']} placement="bottomLeft">
                <a onClick={e => e.preventDefault()}> <EllipsisOutlined /></a>
            </Dropdown>
        </Space>
    )
}

export default InterfaceDropdown